// @ts-ignore
import { DateUtils } from '@fulcrumapp/fulcrum-core';

interface Metadata {
  id: string
  size: string
  latitude?: string
  longitude?: string
  altitude?: number | null
  accuracy?: number | null
  direction?: number | null
  width?: number | null
  height?: number | null
  timestamp?: string | null
  duration?: number | null
  orientation?: string | null
}
export default class MetadataParser {
  parse = (object: any): Metadata => {
    const parsed: Metadata = {
      id: object.access_key,
      size: object.file_size,
    };

    if (object.exif) {
      parsed.latitude = object.latitude ?? null;
      parsed.longitude = object.longitude ?? null;
      parsed.altitude = this.numOrNull(object.exif.gps_altitude);
      parsed.accuracy = this.numOrNull(object.exif.gps_dop);
      parsed.direction = this.numOrNull(object.exif.gps_img_direction);
      parsed.width = this.numOrNull(object.exif.pixel_x_dimension);
      parsed.height = this.numOrNull(object.exif.pixel_y_dimension);
      parsed.timestamp = this.parseTimestamp(object.exif.date_time);
    }

    if (object.metadata?.format) {
      parsed.timestamp = this.parseTimestamp(object.metadata.format?.tags?.creation_time);
      parsed.duration = this.numOrNull(object.metadata.format.duration);

      const videoStream = object.metadata?.streams?.find((s: any) => s.codec_type === 'video');

      if (videoStream) {
        parsed.width = videoStream?.width ?? null;
        parsed.height = videoStream?.height ?? null;
        parsed.orientation = videoStream?.tags?.rotate ?? null;
      }
    }

    return parsed;
  };

  // Coerce a value to a number or null if the value is nullish
  numOrNull = (val?: string | null): number | null => (val != null
    && !Number.isNaN(+val) ? +val : null);

  // Format a Date object. End result: YYYY/MM/DD HH:MM:SS
  formatDateTime = (dateTime: Date): string => {
    // @ts-ignore
    const formattedDate = DateUtils.formatDate(dateTime).replace(/-/g, '/');
    const formattedTime = DateUtils.formatTimeParts(dateTime.getHours(),
      dateTime.getMinutes(),
      dateTime.getSeconds());
    return `${formattedDate} ${formattedTime}`;
  }

  // Parse a string timestamp into a valid and uniform date time string.
  // End result: YYYY/MM/DD HH:MM:SS OR null if the timestamp is unparseable.
  parseTimestamp = (timestamp: string | null): string | null => {
    if (timestamp == null) return null;

    let createdDateTime = new Date(timestamp);

    // If we fail to get a Date object from timestamp, try to parse the
    // string for a space separated datetime.
    if (!this.isValidDate(createdDateTime)) {
      const [date, fullTime] = timestamp.split(' ');
      createdDateTime = new Date(`${date}T${fullTime}Z`);
    }

    if (!this.isValidDate(createdDateTime)) {
      return null;
    }
    return this.formatDateTime(createdDateTime);
  }

  // Check if a Date object is actually a Date and not `invalid date`
  isValidDate = (datetime: Date | null): boolean => datetime != null
    && !Number.isNaN(datetime.getTime())
}
